<div id="logos-mobile-menu" class="unselectable">
  <img alt="menu" class="logos-mobile-menu-button" src="assets/images/menuButton.png" (click)='menuClicked()'>
  <img alt="Logos logo" class="logos-mobile-logo" src="assets/images/logos_logo.png">
  <div class="logos-mobile-languages">
    <a class="logos-mobile-language" [ngClass]="{'selected':currentLanguageKey === 'bg'}" (click)="setLang('bg')"> BG
    </a>
    <a class="logos-mobile-language" [ngClass]="{'selected':currentLanguageKey === 'en'}" (click)="setLang('en')"> EN
    </a>
  </div>
</div>
<div [@showHideMenu]="showHideMenu ? 'openMenu' : 'closeMenu' " id="nav-container">
  <div id="languages-container">
    <a class="language-button" [ngClass]="{'selected':currentLanguageKey === 'bg'}" (click)="setLang('bg')">BG</a>
    <a class="language-button" [ngClass]="{'selected':currentLanguageKey === 'en'}" (click)="setLang('en')">EN</a>
  </div>
  <div id="logo-container">
    <img [src]="'assets/images/logos_logo.png'" alt="Logos_logo">
  </div>
  <nav id="menu-container">
    <ul id="menu-container-list">
      <li class='menu-item'>
        <a (click)='homeClicked()'
           [ngClass]="{'selected':navService.homeSelected}">{{'HOME' | translate | uppercase}}</a>
      </li>
      <li class='menu-item'>
        <a (click)='estatesClicked("estates")'
           [ngClass]="{'selected':navService.estatesSelected}">{{'REAL_ESTATES' | translate | uppercase}}</a>
        <ul class='sub-menu'>
          <li [@openClose]="openEstates ? 'open' : 'close'" class="submenu-item"
              [ngClass]="{'selected':navService.salesSelected}" (click)='estatesClicked("sales")'>
            <a [@openClose]="openEstates ? 'open' : 'close'">{{'SALES' | translate }}</a>
          </li>
          <li [@openClose]="openEstates ? 'open' : 'close'" class="submenu-item "
              [ngClass]="{ 'selected':navService.rentsSelected} " (click)='estatesClicked("rents")'>
            <a [@openClose]="openEstates ? 'open' : 'close'">{{'RENTS' | translate }}</a>
          </li>
        </ul>
      </li>
      <li class='menu-item'>
        <a (click)="newsClicked()"
           [ngClass]="{'selected': navService.newsSelected} ">{{'NEWS' | translate | uppercase}}</a>
      </li>
      <li class='menu-item'>
        <a (click)="servicesClicked()"
           [ngClass]="{'selected': navService.servicesSelected} ">{{'SERVICES' | translate | uppercase}}</a>
      </li>
      <li class='menu-item'>
        <a (click)='helpClicked("helpful")'
           [ngClass]="{ 'selected':navService.helpSelected} ">{{ 'HELPFUL' | translate | uppercase}}</a>
        <ul class='sub-menu'>
          <li [@openClose]="openHelpful ? 'open' : 'close'" class="submenu-item"
              [ngClass]="{ 'selected':navService.regionAndCountrySelected}" (click)='helpClicked("regionAndCountry")'>
            <a [@openClose]="openHelpful ? 'open' : 'close'">{{'ABOUT_COUNTRY_AND_REGION' | translate }}</a>
          </li>
          <li [@openClose]="openHelpful ? 'open' : 'close'" class="submenu-item"
              [ngClass]="{ 'selected':navService.notaryCalculatorSelected} " (click)='helpClicked("notaryCalculator")'>
            <a [@openClose]="openHelpful ? 'open' : 'close'">{{'NOTARY_CALCULATOR' | translate }}</a>
          </li>
          <li [@openCloseHowToSell]="openHelpful ? 'open' : 'close'" class="submenu-item howtosell"
              [ngClass]="{ 'selected':navService.howToSellSelected} " (click)='helpClicked("howToSell")'>
            <a [@openCloseHowToSell]="openHelpful ? 'open' : 'close'">{{'HOW_TO_SELL_YOUR_ESTATE' | translate }}</a>
          </li>
          <li [@openCloseHowToSell]="openHelpful ? 'open' : 'close'" class="submenu-item howtosell"
              [ngClass]="{ 'selected':navService.policySelected} " (click)='helpClicked("policy")'>
            <a [@openCloseHowToSell]="openHelpful ? 'open' : 'close'">{{'POLICY_HEADER' | translate }}</a>
          </li>
        </ul>
      </li>
      <li class='menu-item'>
        <a (click)='aboutClicked("about")'
           [ngClass]="{'selected':navService.aboutSelected}"> {{'ABOUT_US' | translate | uppercase}}</a>
        <ul class='sub-menu'>
          <li [@openClose]="openAboutUs ? 'open' : 'close'" class="submenu-item"
              [ngClass]="{ 'selected':navService.historySelected} " (click)='aboutClicked("history")'>
            <a [@openClose]="openAboutUs ? 'open' : 'close'">{{'COMPANY_HISTORY' | translate }}</a>
          </li>
          <li [@openClose]="openAboutUs ? 'open' : 'close'" class="submenu-item"
              [ngClass]="{ 'selected':navService.principlesSelected} " (click)='aboutClicked("principles")'>
            <a [@openClose]="openAboutUs ? 'open' : 'close'">{{'PRINCIPLES'| translate }}</a>
          </li>
          <li [@openClose]="openAboutUs ? 'open' : 'close'" class="submenu-item"
              [ngClass]="{ 'selected':navService.teamSelected} " (click)='aboutClicked("team")'>
            <a [@openClose]="openAboutUs ? 'open' : 'close'">{{'TEAM' | translate }}</a>
          </li>
        </ul>
      </li>
      <li class='menu-item'>
        <a (click)="contactsClicked() "
           [ngClass]="{ 'selected':navService.contactsSelected} ">{{'CONTACTS' | translate | uppercase}}</a>
      </li>
    </ul>
  </nav>
  <div id="facebook-icon" (click)="clickFbLikeUsPage()">
    <img id="logos-fb-image" src={{fbLogo}} alt="facebook logo">
  </div>
</div>
